export default "<ion-header class=\"header-ios\">\n \n</ion-header>\n\n<ion-content class=\"ion-padding\">\n  \n</ion-content>\n"